import { storageProvider } from '@ocean/configs'

const APRO_TEST_RESULTS_KEY = 'AproTestResults'
const CES_TEST_RESULTS_KEY = 'CesTestResults'

class LegacyTestResultsUtils {
  getAproTestResults() {
    return storageProvider.getItem(APRO_TEST_RESULTS_KEY)
  }

  getCesTestResults() {
    return storageProvider.getItem(CES_TEST_RESULTS_KEY)
  }

  removeAproTestResults() {
    storageProvider.removeItem(APRO_TEST_RESULTS_KEY)
  }

  removeCesTestResults() {
    storageProvider.removeItem(CES_TEST_RESULTS_KEY)
  }

  setCesTestResults(data: string) {
    storageProvider.setItem(CES_TEST_RESULTS_KEY, data)
  }
}

export default new LegacyTestResultsUtils()
